'use client';

import { createContext, useContext } from 'react';
import type { DependencyGraphInstanceManager } from './createDependencyGraphInstanceManager';

// Single context for the per-page dependency graph manager. The page-level
// provider (see PageDependencyGraphManagerProvider) sets the manager once per
// page mount; consumers reach it via useDependencyGraphInstanceManager.
const DependencyGraphInstanceManagerContext = createContext<DependencyGraphInstanceManager | null>(
  null,
);

export { DependencyGraphInstanceManagerContext };

export function useDependencyGraphInstanceManager(): DependencyGraphInstanceManager {
  const context = useContext(DependencyGraphInstanceManagerContext);
  if (!context) {
    throw new Error(
      'useDependencyGraphInstanceManager must be used within a DependencyGraphInstanceManagerContext.Provider',
    );
  }
  return context;
}
